import { __extends, __awaiter, __generator, __decorate, __metadata } from 'tslib';
import { configQuery, FeatureEnabledV2, getItemTime, getItemDate, formatCurrency, toUtc, formatDate, formatTime } from '@gig/magic-common';
import { Watch, Component, Mixins } from 'vue-property-decorator';
import { Currency } from '@gig/magic-sdk/dist/adapter/users/signup';
import { Feature } from '@gig/magic-messages';
import { compactFormatter } from '../../utils/helpers.js';
import { namespace } from 'vuex-class';
import { TRANSACTIONS_NAMESPACE, getSweepxData } from '../../store/modules/transactions/transactions.store.js';
import { store } from '../../store/index.js';
import { CoreXOperationType } from '@gig/magic-sdk/dist/adapter/users/getUserTransactionsHistory';
import { isFiatCurrency } from '@gig/magic-sdk/dist/util/balance';
import { SweepstakesTransactionMixin } from '../sweepstakes-transaction/transaction.js';

var transactions = namespace(TRANSACTIONS_NAMESPACE);
var PurchasesTransactionColumn;
(function (PurchasesTransactionColumn) {
    PurchasesTransactionColumn["DATE"] = "date";
    PurchasesTransactionColumn["TIME"] = "time";
    PurchasesTransactionColumn["PRICE"] = "price";
    PurchasesTransactionColumn["COINS"] = "coins";
    PurchasesTransactionColumn["PROVIDER"] = "provider";
    PurchasesTransactionColumn["ID"] = "id";
})(PurchasesTransactionColumn || (PurchasesTransactionColumn = {}));
/**
 * Fetches and displays the list of bonuses
 * transactions
 */
var PurchaseTransactionsComponent = /** @class */ (function (_super) {
    __extends(PurchaseTransactionsComponent, _super);
    function PurchaseTransactionsComponent() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.pageSize = 10;
        _this.Column = PurchasesTransactionColumn;
        _this.Currency = Currency;
        /**
         * When enabled it will show the time and date
         * in local time instead of UTC.
         */
        _this.isLocalTime = false;
        /**
         * List of columns that should be displayed.
         * This property does not affect the order.
         */
        _this.columns = Object.values(PurchasesTransactionColumn).join(',');
        return _this;
    }
    Object.defineProperty(PurchaseTransactionsComponent.prototype, "shownColumns", {
        get: function () {
            return this.columns
                .split(',')
                .map(function (str) {
                return str.trim();
            });
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(PurchaseTransactionsComponent.prototype, "shownHistory", {
        get: function () {
            var _this = this;
            var _a;
            return (_a = this.transactions) === null || _a === void 0 ? void 0 : _a.map(function (item) {
                var _a = _this.getSweepxInfo(item), sweepCoins = _a.sweepCoins, goldCoins = _a.goldCoins;
                var currency = item.Payload.CurrencyCode;
                return {
                    id: item.TransactionId,
                    date: new Date(item.TimestampEpoch),
                    price: isFiatCurrency(currency) ? item.Payload.Amount : null,
                    currency: currency,
                    sweepCoins: sweepCoins,
                    goldCoins: goldCoins,
                    sweepCoinsFormatted: sweepCoins && compactFormatter.format(sweepCoins),
                    goldCoinsFormatted: goldCoins && compactFormatter.format(goldCoins),
                    provider: _this.getPaymentMethod(item),
                    idLabel: _this.getIdLabel(item),
                };
            });
        },
        enumerable: false,
        configurable: true
    });
    PurchaseTransactionsComponent.prototype.created = function () {
        var _this = this;
        configQuery('wallet.purchaseHistoryColumns', function (columns) {
            if (!columns) {
                return;
            }
            _this.columns = columns.join(',');
            _this.columnsValidator(_this.columns);
        });
        this.fetchData();
    };
    PurchaseTransactionsComponent.prototype.getSweepxInfo = function (item) {
        try {
            var SweepStakesShop = getSweepxData(item);
            return {
                sweepCoins: SweepStakesShop.CurrencyCodes[Currency.SWP],
                goldCoins: SweepStakesShop.CurrencyCodes[Currency.GLD],
            };
        }
        catch (_a) {
            if (item.Payload.CurrencyCode === Currency.SWP) {
                return { sweepCoins: item.Payload.Amount, goldCoins: 0 };
            }
            else if (item.Payload.CurrencyCode === Currency.GLD) {
                return { goldCoins: item.Payload.Amount, sweepCoins: 0 };
            }
            return { sweepCoins: 0, goldCoins: 0 };
        }
    };
    PurchaseTransactionsComponent.prototype.columnsValidator = function (columns) {
        var found = columns.split(',');
        var allValues = Object.values(PurchasesTransactionColumn);
        return found.every(function (column) {
            return allValues.includes(column.trim());
        });
    };
    PurchaseTransactionsComponent.prototype.isColumnShown = function (column) {
        return this.shownColumns.includes(column);
    };
    PurchaseTransactionsComponent.prototype.loadMore = function () {
        this.fetchData({ loadMore: true });
    };
    PurchaseTransactionsComponent.prototype.fetchData = function (_a) {
        var _b = _a === void 0 ? {} : _a, _c = _b.loadMore, loadMore = _c === void 0 ? false : _c;
        return __awaiter(this, void 0, void 0, function () {
            var e_1;
            return __generator(this, function (_d) {
                switch (_d.label) {
                    case 0:
                        if (!this.from || !this.to) {
                            return [2 /*return*/];
                        }
                        _d.label = 1;
                    case 1:
                        _d.trys.push([1, 3, , 4]);
                        this.onContentLoadInit();
                        return [4 /*yield*/, this.fetchTransactions({
                                from: this.fromDate,
                                to: this.toDate,
                                size: this.pageSize,
                                typeFilter: CoreXOperationType.CREDIT,
                                loadMore: loadMore,
                            })];
                    case 2:
                        _d.sent();
                        this.onContentLoad(this.transactions);
                        if (loadMore) {
                            this.scrollToBottomOfPayment();
                        }
                        return [3 /*break*/, 4];
                    case 3:
                        e_1 = _d.sent();
                        this.onContentLoadError(e_1);
                        return [3 /*break*/, 4];
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    __decorate([
        FeatureEnabledV2({
            slug: Feature.TRANSACTIONS_HISTORY_ON_LOCAL_TIME,
        }),
        __metadata("design:type", Boolean)
    ], PurchaseTransactionsComponent.prototype, "isLocalTime", void 0);
    __decorate([
        transactions.Getter('isLoadingState'),
        __metadata("design:type", void 0)
    ], PurchaseTransactionsComponent.prototype, "isLoading", void 0);
    __decorate([
        transactions.Getter('hasMoreRows'),
        __metadata("design:type", void 0)
    ], PurchaseTransactionsComponent.prototype, "hasMoreRows", void 0);
    __decorate([
        transactions.Getter('getPurchaseTransactions'),
        __metadata("design:type", void 0)
    ], PurchaseTransactionsComponent.prototype, "transactions", void 0);
    __decorate([
        transactions.Action('fetchTransactions'),
        __metadata("design:type", Object)
    ], PurchaseTransactionsComponent.prototype, "fetchTransactions", void 0);
    __decorate([
        Watch('from'),
        Watch('to'),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object]),
        __metadata("design:returntype", Promise)
    ], PurchaseTransactionsComponent.prototype, "fetchData", null);
    PurchaseTransactionsComponent = __decorate([
        Component({
            name: 'corex-purchase-transactions',
            methods: { getItemTime: getItemTime, getItemDate: getItemDate },
            store: store,
            filters: {
                formatCurrency: formatCurrency,
                toUtc: toUtc,
                formatDate: formatDate,
                formatTime: formatTime,
            },
        })
    ], PurchaseTransactionsComponent);
    return PurchaseTransactionsComponent;
}(Mixins(SweepstakesTransactionMixin)));

export default PurchaseTransactionsComponent;
